import React from 'react';
import { INDUSTRIES, PRODUCTS, ACCENT } from './data.js';
import { Link, ContactButton } from './ui.jsx';

export function IndustryPage({ industryKey }) {
  const d = INDUSTRIES.find(x => x.key === industryKey);
  return (
    <>
      <section className="band-dk dots i-hero">
        <div className="wrap inner">
          <nav className="crumbs" aria-label="Breadcrumb">
            <Link to="/">Home</Link><span>/</span><Link to="/#solutions">Solutions</Link><span>/</span><span aria-current="page">{d.name}</span>
          </nav>
          <div className="grid g2 cols">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
              <div className="eyebrow ac">{`SOLUTIONS · ${d.name.toUpperCase()}`}</div>
              <h1>{d.h}</h1>
              <p className="intro">{d.intro}</p>
              <div><ContactButton>Talk about your line →</ContactButton></div>
            </div>
            <Feed d={d} />
          </div>
        </div>
      </section>

      <section className="wrap sec">
        <div className="eyebrow">WHAT'S AT STAKE</div>
        <h2 className="h2">{d.stakeTitle}</h2>
        <div className="grid g3" style={{ columnGap: 40, rowGap: 16 }}>
          {d.stakes.map(s => (
            <div className="stake" key={s.t}>
              <div className="tag-chip problem">RISK</div>
              <div className="t">{s.t}</div>
              <div className="src">{s.src}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="wrap" style={{ paddingTop: 0, paddingBottom: 72 }}>
        <div className="eyebrow">WHAT VIAI CATCHES</div>
        <div className="grid g4" style={{ marginTop: 24, gap: 16 }}>
          {d.defects.map(x => (
            <div className="defect" key={x.code}>
              <div className="top"><div>{x.code}</div><i /></div>
              <div className="n">{x.n}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="band-2">
        <div className="wrap sec">
          <div className="eyebrow">WHERE IT SITS ON YOUR LINE</div>
          <h2 className="h2">Three typical stations.</h2>
          <div className="grid g3" style={{ gap: 0 }}>
            {d.stations.map(s => (
              <div className="station" key={s.n}>
                <div className="rail"><i>{s.n}</i><b /></div>
                <div className="t">{s.t}</div>
                <div className="d">{s.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="wrap sec">
        <div className="eyebrow">HOW VIAI FITS</div>
        <h2 className="h2">Your problems, and the product that solves each one.</h2>
        <div className="ps">
          {d.fit.map(f => {
            const prod = PRODUCTS.find(p => p.key === f.prod);
            return (
              <div className="ps-row" key={f.need} style={{ '--pac': ACCENT[f.prod] }}>
                <div className="ps-p" style={{ padding: '20px 22px' }}><div className="tag-chip problem">PROBLEM</div><div style={{ fontWeight: 500 }}>{f.need}</div></div>
                <div className="arrow" aria-hidden="true">→</div>
                <div className="fit-s">
                  <div className="body"><div className="k">SOLUTION</div><div>{f.how}</div></div>
                  <Link to={'/product/' + f.prod}>{`${prod.name} →`}</Link>
                </div>
              </div>
            );
          })}
        </div>
        <div className="related" style={{ gap: 10 }}>
          <div className="lbl">ALIGNED WITH</div>
          {d.std.map(s => <div className="std" key={s}>{s}</div>)}
          <div className="muted" style={{ fontSize: 14, marginLeft: 8 }}>Final line certification stays with your QA team.</div>
        </div>
      </section>
    </>
  );
}

// Schematic camera view: the design's photo slot has no imagery yet, so
// this draws a generic part under inspection with the reject overlay.
function Feed({ d }) {
  return (
    <div className="feed" role="img" aria-label={`Camera view: ${d.demo}`}>
      <svg viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <rect x="0" y="206" width="400" height="2" fill="rgba(196,202,212,.25)" />
        <rect x="0" y="212" width="400" height="1" fill="rgba(196,202,212,.12)" />
        <rect x="58" y="96" width="70" height="110" rx="10" fill="none" stroke="rgba(230,234,242,.35)" strokeWidth="1.5" />
        <rect x="160" y="80" width="112" height="126" rx="12" fill="none" stroke="rgba(230,234,242,.6)" strokeWidth="1.5" />
        <rect x="304" y="96" width="70" height="110" rx="10" fill="none" stroke="rgba(230,234,242,.35)" strokeWidth="1.5" />
        <path d="M188 128 l14 10 l8 -8 l16 14" fill="none" stroke="#FF5C6C" strokeWidth="1.5" />
      </svg>
      <div className="box" />
      <div className="lbl">{d.demo}</div>
      <div className="live">● LIVE</div>
      <div className="cam">{d.cam}</div>
    </div>
  );
}
